<template>
  <div>
    <div style="display: flex">
      <span class="mr-5">
        <b-button variant="outline-primary" size="sm" @click="modal = !modal"
          >Select</b-button
        >
      </span>

      <span class="mr-3">{{ result.length }} codes had been selected</span>
    </div>
    <b-modal v-model="modal" title="Member Codes" ok-only>
      <b-row>
        <b-col cols="12" class="m-2">
          <small
            >Upload excel file containing the codes in the first column without
            header</small
          >
        </b-col>
        <b-col cols="12">
          <b-form-file
            size="sm"
            v-model="file"
            placeholder="Upload file here..."
            drop-placeholder="Drop file here..."
            accept=".xlsx, .xls"
          ></b-form-file>
        </b-col>
        <b-col cols="12" class="m-2">
          <small>or type them directly as comma separated string</small>
        </b-col>
        <b-col cols="12">
          <b-input
            size="sm"
            type="text"
            placeholder="e.g.   code1,code2,code3"
            v-model="csv"
            @focus="
              $event.target.setSelectionRange(0, $event.target.value.length)
            "
          />
        </b-col>
        <b-col cols="12" v-if="result.length > 0">
          <div class="my-2">
            <small class="text-primary"
              >{{ result.length }} codes had been selected</small
            >
          </div>
          <div class="ml-2">
            <div>Samples:</div>
            <div v-for="(item, index) in result.slice(0, 10)" :key="index">
              <small>{{ item }}</small>
            </div>
            <div v-if="result.length > 10">
              <small>...</small>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/*global _*/
import XLSX from 'xlsx';

export default {
  props: ['filter'],
  data() {
    return {
      modal: false,
      file: null,
      csv: ''
    };
  },
  mounted() {
    this.UpdateData();
  },
  computed: {
    list() {
      var vm = this;
      return _.map(vm.result, function(row) {
        return vm.filter.level.levelId + '.&[' + row + ']';
      });
    },
    result() {
      var list = this.csv.replace(/[^0-9a-z,-_.]/gi, '').split(',');
      list = _.map(list, function(a) {
        return a.substring(0, 50);
      });
      list = _.uniq(list);
      return list.filter(Boolean);
    }
  },
  watch: {
    result() {
      this.UpdateData();
    },
    file(newVal) {
      var vm = this;
      var reader = new FileReader();
      var file = newVal;
      if (file.name) {
        var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        if (!regex.test(file.name.toLowerCase())) {
          vm.$bvToast.toast(
            `Only xlsx and xls files are accepted. Please upload again.`,
            {
              title: 'File format',
              variant: 'warning',
              autoHideDelay: 5000,
              appendToast: true
            }
          );
        }

        reader.onload = function(e) {
          var result = '';
          try {
            var buffer = e.target.result;
            var uint8Arr = new Uint8Array(buffer);
            var data = '';
            for (var i = 0; i < uint8Arr.byteLength; i++) {
              data += String.fromCharCode(uint8Arr[i]);
            }
            //Read the workbook as array
            var wb = XLSX.read(data, { type: 'binary' });
            //Get the first Worksheet
            var ws = wb.Sheets[wb.SheetNames[0]];
            //Convert the first worksheet to csv (no comma because only the first column is used)
            var csv = XLSX.utils.sheet_to_csv(ws);
            var csvArr = csv.split('\n');
            csvArr = _.map(csvArr, function(row) {
              return row.split(',')[0];
            });
            //convert csv to array
            result = csvArr.join(',');
          } catch (e) {
            vm.$bvToast.toast(
              `Failed to process the uploaded file. Please try again.`,
              {
                title: 'Failed to load.',
                variant: 'warning',
                autoHideDelay: 5000,
                appendToast: true
              }
            );
          }
          vm.csv = result;
        };

        reader.readAsArrayBuffer(file);
      }
    }
  },
  methods: {
    UpdateData() {
      this.$emit('input', this.list);
    },
    ClearAll() {
      this.result = [];
    }
  }
};
</script>
